import React, { useEffect, useState } from "react";
import { Modal, Box, Typography, TextField, MenuItem, CircularProgress } from "@mui/material";
import MDButton from "components/MDButton";
import { useAlerta } from "utils/alertas";

export default function EditarGrupoModal({ open, onClose, grupoId, onGrupoActualizado, tipo, carrera_id}) {
  const [loading, setLoading] = useState(false);
  const [cargandoDatos, setCargandoDatos] = useState(true);

  const [nombre, setNombre] = useState("");
  const [turno, setTurno] = useState("");
  const [modalidad, setModalidad] = useState("");
  const [dias, setDias] = useState("");
  const [capacidad, setCapacidad] = useState("");
  const [gestion, setGestion] = useState("");
  const [semestre, setSemestre] = useState("");
  const [gestiones, setGestiones] = useState([]);
  const [semestres, setSemestres] = useState([]);
  const [estado, setEstado] = useState(1);
  const { mostrarAlerta } = useAlerta();

  const token = sessionStorage.getItem("access_token");

  // Cargar gestiones
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/gestiones`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(data => setGestiones(data.data || data))
      .catch(err => console.error(err));
  }, [token]);

  // Cargar semestres
 const cargarSemestres = (tipo, carrera_id) => {
 
     fetch(`${process.env.REACT_APP_API_URL}/semestre/${tipo}/${carrera_id}`,{
       headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
     })
     .then((res) => res.json())
     .then((data)=> {
       setSemestres(data.data || []);
     })
     .catch((err)=>{
       console.error(err);
       setSemestres([]);
     });
   }
 
   useEffect(() => {
  if (open && tipo && carrera_id) {
    cargarSemestres(tipo, carrera_id);
  }
}, [open, tipo, carrera_id]);

  // 🔹 Cargar datos del grupo cuando se abre el modal
  useEffect(() => {
    if (!grupoId) return;

    setCargandoDatos(true);
    fetch(`${process.env.REACT_APP_API_URL}/modulos/grupos/${grupoId}`, {
      headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
    })
      .then(res => res.json())
      .then(data => {
        const grupo = data.data || data;
        setNombre(grupo.nombre || "");
        setTurno(grupo.turno || "");
        setModalidad(grupo.modalidad || "");
        setGestion(grupo.gestion_id || "");
        setSemestre(grupo.semestre_id || "");
        setDias(grupo.dias || "");
        setCapacidad(grupo.cupo_maximo || "");
        setEstado(grupo.estado ?? 1);
        setCargandoDatos(false);
      })
      .catch(err => {
        console.error(err);
        setCargandoDatos(false);
      });
  }, [grupoId, token]);

  // 🔹 Guardar cambios
  const handleSubmit = async () => {
    if (!nombre.trim()) {
      alert("El nombre del grupo es obligatorio");
      return;
    }
    setLoading(true);

    try {
      const payload = {
        nombre,
        turno,
        modalidad,
        gestion_id: gestion,
        semestre_id: semestre,
        dias,
        cupo_maximo: capacidad ? parseInt(capacidad) : null,
        estado,
      };

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/modulos/grupos/${grupoId}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Error al actualizar grupo");
      mostrarAlerta("Grupo actualizado correctamente","success");
      onGrupoActualizado();
      onClose();
    } catch (error) {
      console.error("Error al actualizar grupo:", error);
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" mb={2}>
          Editar Grupo
        </Typography>

        {cargandoDatos ? (
          <CircularProgress />
        ) : (
          <>
            <TextField
              fullWidth
              label="Nombre del Grupo"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              select
              fullWidth
              label="Turno"
              value={turno}
              onChange={(e) => setTurno(e.target.value)}
              SelectProps={{ native: true }}
              sx={{ mb: 2 }}
            >
              <option value=""></option>
              <option value="mañana">Mañana</option>
              <option value="tarde">Tarde</option>
              <option value="noche">Noche</option>
            </TextField>
            <TextField
              select
              fullWidth
              label="Modalidad"
              value={modalidad}
              onChange={(e) => setModalidad(e.target.value)}
              SelectProps={{ native: true }}
              sx={{ mb: 2 }}
            >
              <option value=""> </option>
              <option value="presencial">Presencial</option>
              <option value="semipresencial">Semi presencial</option>
              <option value="virtual">Virtual</option>
            </TextField>
            <TextField
              select
              fullWidth
              label="Gestión Académica"
              value={gestion}
              onChange={(e) => setGestion(e.target.value)}
              SelectProps={{ native: true }}
              sx={{ mb: 2 }}
            >
              <option value=""></option>
              {gestiones.map((g) => (
                <option key={g.id} value={g.id}>
                  {g.nombre}
                </option>
              ))}
            </TextField>
            <TextField
              select
              fullWidth
              label="Semestre/Año"
              value={semestre}
              onChange={(e) => setSemestre(e.target.value)}
              SelectProps={{ native: true }}
              sx={{ mb: 2 }}
            >
              <option value=""></option>
              {Array.isArray(semestres) &&
                semestres.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.nombre} {s.numero}
                  </option>
                ))
              } 
            </TextField>
            <TextField
              select
              fullWidth
              label="Dias"
              value={dias}
              onChange={(e) => setDias(e.target.value)}
              SelectProps={{ native: true }}
              sx={{ mb: 2 }}
            >
              <option value=""></option>
              <option value="lunes_a_viernes">Lunes a Viernes</option>
              <option value="lunes_miercoles_viernes">Lunes, Miércoles, Viernes</option>
              <option value="martes_jueves">Martes, Jueves</option>
              <option value="sabado">Sábado</option>
            </TextField>
            <TextField
              fullWidth
              label="Capacidad"
              type="number"
              value={capacidad}
              onChange={(e) => setCapacidad(e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              select
              fullWidth
              label="Estado"
              value={estado}
              onChange={(e) => setEstado(parseInt(e.target.value))}
              SelectProps={{ native: true }}
              sx={{ mb: 2 }}
            >
              <option value={1}>Activo</option>
              <option value={0}>Inactivo</option>
            </TextField>

            <MDButton
              variant="contained"
              color="info"
              fullWidth
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "Guardar cambios"}
            </MDButton>
          </>
        )}
      </Box>
    </Modal>
  );
}
